import styled from "styled-components";

export const ProductsContainer = styled.div`
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px 10px;
`;
